
<div class="container-fluid">
  <div class="row">
    <section class="main-wrapper">
      <div class="dis-table">
        <div class="dis-table-cell">
          <div class="container-form">
            <div class="form-wrapper">
              <div class="module form-module">
                <div class="form signup box-container">
                  <div class="text-center">
                    <img src="../../../assets/images/access-denied.png"
                         alt="img">
                  </div>
                  <div *ngIf="!isTerminated">
                    <h1 class="title text-center mt-4">
                      {{ 'common.access-deniedTitle'  |translate}}
                    </h1>
                    <p class="text-center font-size-small ">
                      {{ 'common.access-deniedDesc'  |translate}}
                    </p>
                    <br>
                    <p class="text-center ">
                      <a class="forgot">{{'menu.Home' | translate}}</a>
                    </p>
                  </div>
                  <div *ngIf="isTerminated">
                    <h1 class="title text-center mt-4">
                      {{ 'common.access-deniedTitle'  |translate}}
                    </h1>
                    <p class="text-center font-size-small ">
                      {{ 'common.access-TerminatedDesc'  |translate}}
                    </p>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
